// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"86e68d68","124":"ebafe846","177":"cbdc5905","319":"53e6b4d6","453":"d08f93ad","579":"6b28e731","965":"f1e590f0"}[chunkId] + ".chunk.js";
};